import { operationInProgress } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'

/*
Actions to be dispatched for signin
- add callback request
    addCallback Get surgeon information for given company

*/
export function serviceError(bool, message) {
  return {
    type: ActionType.MESSAGE_SERVICE_ERROR,
    hasError: bool,
    message,
  }
}

export function messageRowSelect(selectedRequests) {
  return {
    type: ActionType.MESSAGE_ROW_SELECT,
    selectedRequests,
  }
}

export function FullfillmentRowSelect(fullfillmentRequests) {
  return {
    type: ActionType.FULLFILLMENT_ROW_SELECT,
    fullfillmentRequests,
  }
}

export function fetchInProgress(bool) {
  return {
    type: ActionType.MESSAGE_INPROGRESS,
    isLoading: bool,
  }
}

export function requestList(data, params, selectedRequests) {
  var filters = JSON.parse(JSON.stringify(params))
  delete filters.total
  delete filters.pagination

  return {
    type: ActionType.MESSAGE_LIST,
    requests: data.requests,
    filters,
    pagination: params.pagination,
    sort: params.sort,
    selectedRequests,
  }
}

export function addCallback(patientid, request) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .CallbackService()
        .addCallback(patientid, request)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}

export function deleteMessages(ids) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.CallbackService().deleteMessage(ids)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}

export function getMessageList(filter, selectedRequests) {
  return async (dispatch) => {
    try {
      console.log('getting patients')
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.CallbackService().getMessages(filter)
      dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(requestList(data, data.metadata, selectedRequests))
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
